import { CartServices, ProductType, Service, PAGEACTIVITY } from './../../constants/actionType'
import { InHomeUtils } from './inhomeUtils'
import { catchJSException, logOtherInfo, detailsInfo } from './../../service/logService'
import { replaceCartDataText } from '../cartUtility';

export const getCartHeader = (cartResponse, visitId = null) => {
    let cartHeader = [];
    cartHeader = getCartHeaderArray(cartResponse, visitId);
    return cartHeader;
}

export const getCartDataDefault = () => {
    let cartData = {
        serviceHeaders: null, internet: null, channel: null,removedchannel: null, removedotherchannel: null, listing: null,
        streamService: null, equipments: [], removedServices: [], removedequipments: [], oneTimeCharge: [], Promotions: [],
        rewardOffers: [], youtubePrd: [], channelsNotInPack: [], fiosFiveSelectedChannels: [], returnedEquipment: [], removedStreamServices: [], intrnlChannel:null, perks: [], removedperks:null
    }
    return cartData;
}

export const getCartHeaderArray = (cartResponse, visitId = null) => {
    let tierHeader = [];
    let tierHeaders = {
        tierHeader: null
    };
    try {
        if (InHomeUtils.isNotNull(cartResponse)) {
            for (let cartHeaderArrays in cartResponse) {
                tierHeaders.tierHeader = Object.assign({
                    cartID: cartResponse[cartHeaderArrays].id,
                    title: cartResponse[cartHeaderArrays].tierTitle,
                    totalPrice: cartResponse[cartHeaderArrays].totalMonthlyPrice,
                    totalNrcPrice: cartResponse[cartHeaderArrays].totalNrcPrice,
                    monthlyRcPrice: cartResponse[cartHeaderArrays].monthlyRcPrice,
                    monthlyNrcPrice: cartResponse[cartHeaderArrays].monthlyNrcPrice
                })
                tierHeader.push(tierHeaders.tierHeader);
            }
        }
        else {
            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.CART, visitId, 'getCartHeaderArray', PAGEACTIVITY.MSG.cartResponseNull, PAGEACTIVITY.UA));
        }
    }
    catch (ex) {
        catchJSException('cartUtility', visitId, 'getCartHeaderArray', ex);
    }

    return tierHeader;
}

export const getProfileCart = (cartData) => {
    let profileCartData = {
        "title": "",
        "totalPrice": "",
        "priceDescription": "",
        "description": "",
        "contract": ""
    };
    if (cartData && cartData.tierHeader && Array.isArray(cartData.tierHeader) && cartData.tierHeader.length) {
        profileCartData = cartData.tierHeader[0];
    }
    return profileCartData;
}

export const getSubProduct = (subSection, visitId) => {
    let subProducts = [];
    try {
        subSection.forEach(subSec => {
            subProducts.push.apply(subProducts, subSec.products);
        })
    }
    catch (ex) {
        catchJSException('cartUtility', visitId, 'getSubProduct', ex);
    }

    return subProducts;
}

export const getCartData = (cartResponse, visitId = null) => {
    let cartData = getCartDataDefault();

    let cartspilitData = [];
    try {
        if (InHomeUtils.isNotNull(cartResponse)) {
            for (let cartdatas in cartResponse) {
                for (let secIndex in cartResponse[cartdatas].sections.section) {
                    //Render Service Header and Special Offers and Offers 
                    let cartSection = cartResponse[cartdatas].sections.section[secIndex];
                    if (InHomeUtils.isNotNull(cartSection.sectionName)){
                    if (cartSection.sectionName.toLowerCase() === CartServices.Service) {
                        for (let serviceprod in cartSection.subSections.subSection) {
                            let cartSubSection = cartSection.subSections.subSection[serviceprod];
                            if (cartSubSection.sectionType !== undefined && cartSubSection.sectionType !== null) {
                                switch (cartSubSection.sectionType) {
                                    case CartServices.bundle:
                                    case CartServices.dataStandalone:
                                    case CartServices.tvStandalone:
                                    case CartServices.voiceStandalone:
                                        // Section Header should check with Standalone || Bundles 
                                        let subSectionProducts = cartSubSection && cartSubSection.products && cartSubSection.products.length || 0;
                                        if (serviceprod < 1) {
                                            let filteredProducts = cartSubSection.products.filter(prod => InHomeUtils.isNotEmpty(prod.prodType) && prod.prodType !== "BASIC_FF");
                                            
                                            cartData.serviceHeaders = Object.assign({
                                                servicehead: filteredProducts,
                                                // servicePromos: cartSubSection.promos,
                                                totalPrice: cartSubSection.sectionTotalprice,
                                                title: cartSubSection.title
                                            })
                                                                                    
                                            if (cartSubSection.sectionType === CartServices.tvStandalone && subSectionProducts > 0) {
                                                let cartProducts = '';
                                                cartSubSection.products.forEach(function (prod) {
                                                    if (cartProducts.indexOf(prod.prodId) < 0) {
                                                        if (InHomeUtils.isNotEmpty(prod.prodType) && prod.prodType === "BASIC_FF") {
                                                            cartData.fiosFiveSelectedChannels.push(prod);
                                                        }
                                                    }
                                                });
                                            }
                                        }
                                        else {
                                            if (subSectionProducts > 0) {
                                                let cartProducts = '';
                                                let prodId = cartSubSection.products[0].prodId;
                                                if (prodId !== '') {
                                                    cartData.serviceHeaders.servicehead.forEach(function (prod) {
                                                        cartProducts += prod.prodId + ",";
                                                    });
                                                }

                                                cartSubSection.products.forEach(function (prod) {
                                                    if (cartProducts.indexOf(prod.prodId) < 0) {
                                                        if (cartSubSection.sectionType === CartServices.tvStandalone && InHomeUtils.isNotEmpty(prod.prodType) && prod.prodType === "BASIC_FF") {
                                                            cartData.fiosFiveSelectedChannels.push(prod);
                                                        } else {
                                                            cartData.serviceHeaders.servicehead.push(prod);
                                                        }
                                                    }
                                                });
                                            }
                                        }
                                        break;

                                    case CartServices.internet:
                                        //Rendering Internet Products Like VASIP Products
                                        let internetProds =[]
                                        // cartData.internet = Object.assign({
                                        //     internetProds: cartSubSection.products,
                                        //     internetPromos: cartSubSection.promos,
                                        //     internetTotalPrice: cartSubSection.sectionTotalprice,
                                        //     internettitle: cartSubSection.title
                                        // })                                   
                       
                                            cartSubSection.products.forEach(function (prod) {                                                                                        
                                                    internetProds.push(prod);
                                            });
                                            cartData.internet = Object.assign({
                                            internetProds: internetProds,
                                            internetPromos: cartSubSection.promos,
                                            internetTotalPrice: cartSubSection.sectionTotalprice,
                                            internettitle: cartSubSection.title
                                        })
                                        break;

                                    case CartServices.channel:
                                        // Rendering TV Section Here 
                                        cartData.channel = Object.assign({
                                            channelsProds: cartSubSection.products,
                                            channelsPromos: cartSubSection.promos,
                                            channelsTotalprice: cartSubSection.sectionTotalprice,
                                            channelstitle: cartSubSection.title
                                        })
                                        break;
                                    case CartServices.intrnlChannel:
                                        // Rendering international TV Section Here 
                                        cartData.intrnlChannel = Object.assign({
                                            intrnlChannelsProds: cartSubSection.products,
                                            intrnlChannelsPromos: cartSubSection.promos,
                                            intrnlChannelsTotalprice: cartSubSection.sectionTotalprice,
                                            intrnlChannelstitle: cartSubSection.title
                                        })
                                        break;
                                    case CartServices.channelsNotInPack:
                                        // Rendering TV Section Here 
                                        cartData.channelsNotInPack = Object.assign({
                                            channelsProds: cartSubSection.products,
                                            channelsPromos: cartSubSection.promos,
                                            channelsTotalprice: cartSubSection.sectionTotalprice,
                                            channelstitle: cartSubSection.title
                                        })
                                        break;

                                    case CartServices.listing:
                                        //Rendering Phone Section Here
                                        cartData.listing = Object.assign({
                                            listingProds: cartSubSection.products,
                                            listingPromos: cartSubSection.promos,
                                            listingTotalprice: cartSubSection.sectionTotalprice,
                                            listingtitle: cartSubSection.title
                                        })

                                        break;

                                    case CartServices.streamService:
                                        cartData.streamService = Object.assign({
                                            streamServiceProds: cartSubSection.products,
                                            streamServicePromos: cartSubSection.promos,
                                            streamServiceTotalprice: cartSubSection.sectionTotalprice,
                                            streamServicetitle: cartSubSection.title
                                        })
                                        break;
                                    default:
                                        break;
                                }
                            }
                        }
                    }
                    else if (cartSection.sectionName.toLowerCase() === CartServices.RemovedService.toLowerCase()) {
                        for (let serviceprod in cartSection?.subSections?.subSection) {
                            let cartSubSection = cartSection?.subSections?.subSection[serviceprod];
                            if (cartSubSection?.sectionType !== undefined && cartSubSection?.sectionType !== null) {
                                switch (cartSubSection.sectionType) {
                                    case CartServices.dataStandalone: 
                                    case CartServices.tvStandalone:
                                    case CartServices.voiceStandalone:
                                        // Section Header should check with Standalone || Bundles 
                                        let subSectionProducts = cartSubSection && cartSubSection?.products && cartSubSection?.products.length || 0;
                                        if (serviceprod < 1) {
                                            cartSubSection?.products?.forEach(function (prod) {
                                                if (InHomeUtils.isNotEmpty(prod?.prodType) && (prod?.prodType === "FTTPD" || prod?.prodType === "BASIC" || prod?.prodType === "FVPRIMARY")) {
                                                    cartData?.removedServices?.push(prod);
                                                }

                                            });
                                        }
                                        else {
                                            if (subSectionProducts > 0) {
                                                let cartProducts = '';
                                                let prodId = cartSubSection.products[0].prodId;
                                                if (prodId !== '') {
                                                    cartSubSection.products.forEach(function (prod) {
                                                        cartProducts += prod.prodId + ",";
                                                    });
                                                }

                                                cartSubSection?.products?.forEach(function (prod) {
                                                    if (cartProducts?.indexOf(prod?.prodId) > -1) {
                                                        if (cartSubSection?.sectionType === CartServices?.tvStandalone && InHomeUtils.isNotEmpty(prod?.prodType) && prod?.prodType === "BASIC_FF") {
                                                            cartData?.fiosFiveSelectedChannels?.push(prod);
                                                        } else {
                                                            cartData?.removedServices?.push(prod);
                                                        }
                                                    }
                                                });
                                            }
                                        }
                                        break;

                                    case CartServices.internet:
                                        //Rendering Internet Products Like VASIP Products
                                        if(cartData.removedServices){
                                        cartSubSection.products && cartSubSection.products.map(each=> cartData.removedServices.push(each))}
                                        // cartData.removedServices.push(cartSubSection.products);
                                        // cartData.internet = Object.assign({
                                        //     // internetProds: cartSubSection.products,
                                        //     internetPromos: cartSubSection.promos,
                                        //     internetTotalPrice: cartSubSection.sectionTotalprice,
                                        //     internettitle: cartSubSection.title
                                        // })
                                        break;

                                    case CartServices.channel:
                                        // Rendering TV Section Here 
                                        cartData.removedchannel = Object.assign({
                                            channelsProds: cartSubSection.products,
                                            channelsPromos: cartSubSection.promos,
                                            channelsTotalprice: cartSubSection.sectionTotalprice,
                                            channelstitle: cartSubSection.title
                                        })
                                        break;
                                    case CartServices.otherChannel:
                                        // Rendering TV Section Here 
                                        cartData.removedotherchannel = Object.assign({
                                            channelsProds: cartSubSection.products,
                                            channelsPromos: cartSubSection.promos,
                                            channelsTotalprice: cartSubSection.sectionTotalprice,
                                            channelstitle: cartSubSection.title
                                        })
                                        break;
                                        
                                    case CartServices.channelsNotInPack:
                                        // Rendering TV Section Here 
                                        cartData.channelsNotInPack = Object.assign({
                                            channelsProds: cartSubSection.products,
                                            channelsPromos: cartSubSection.promos,
                                            channelsTotalprice: cartSubSection.sectionTotalprice,
                                            channelstitle: cartSubSection.title
                                        })
                                        break;

                                    /*case CartServices.listing:
                                        //Rendering Phone Section Here
                                        cartData.listing = Object.assign({
                                            listingProds: cartSubSection.products,
                                            listingPromos: cartSubSection.promos,
                                            listingTotalprice: cartSubSection.sectionTotalprice,
                                            listingtitle: cartSubSection.title
                                        })

                                        break;
                                    */
                                    case CartServices.streamService:
                                        cartData.streamService = Object.assign({
                                            streamServiceProds: cartSubSection.products,
                                            streamServicePromos: cartSubSection.promos,
                                            streamServiceTotalprice: cartSubSection.sectionTotalprice,
                                            streamServicetitle: cartSubSection.title
                                        })
                                        break;
                                    default:
                                        break;
                                }
                            }
                        }
                    }
                    else if (cartSection.sectionName === CartServices.equipment) {
                        let equipment = []
                        cartSection.subSections.subSection.forEach(subSec => {
                            if (subSec.products[0].prodId !== "NODCT" && subSec.products[0].prodId !== "NORECORD" && subSec.products[0].prodId !== "NOVROOM") {
                                equipment.push.apply(equipment, subSec.products);
                            }
                        })
                        cartData.equipments = Object.assign({ equipment: equipment })
                    }
                    else if (cartSection.sectionName === CartServices.removedequipment) {
                        let removedequipment = []
                        cartSection.subSections.subSection.forEach(subSec => {
                            if (subSec.products[0].prodId !== "NODCT" && subSec.products[0].prodId !== "NORECORD" && subSec.products[0].prodId !== "NOVROOM") {
                                removedequipment.push.apply(removedequipment, subSec.products);
                            }
                        })
                        cartData.removedequipments = Object.assign({ equipment: removedequipment })
                    }
                    else if (cartSection.sectionName === CartServices.returnedequipment) {
                        let returnedequipment = []
                        cartSection.subSections.subSection.forEach(subSec => {
                            if (subSec.products[0].prodId !== "NODCT" && subSec.products[0].prodId !== "NORECORD" && subSec.products[0].prodId !== "NOVROOM") {
                                returnedequipment.push.apply(returnedequipment, subSec.products);
                            }
                        })
                        cartData.returnedEquipment = Object.assign({ equipment: returnedequipment })
                    }
                    else if (cartSection.sectionName === CartServices.removedStreamServices) {
                        let removedStreamServices = []
                        cartSection.subSections.subSection.forEach(subSec => {                            
                            removedStreamServices.push.apply(removedStreamServices, subSec.products);
                        })
                        cartData.removedStreamServices = Object.assign({ removedStream: removedStreamServices })
                    }
                    else if (cartSection.sectionName === CartServices.streamDevice) {
                        let streamDev = []
                        streamDev = getSubProduct(cartSection.subSections.subSection, visitId);
                        cartData.streamDev = Object.assign({ streamDevProds: streamDev })
                    }
                    else if (cartSection.sectionName === CartServices.Promotions) {
                        let Promotions = []
                        let rewardOffers = []
                        let youtubePrd = [];
                        cartSection.subSections.subSection.forEach(subSec => {
                            if (subSec.sectionType === "Offers") {
                                let replacedPromos = replaceCartDataText(subSec?.promos, CartServices.Offers);
                                Promotions.push.apply(Promotions, replacedPromos);
                            }
                            else if (subSec.sectionType === "PROMOTIONS") {
                                Promotions.push.apply(Promotions, subSec.promotions);
                            }
                            else if (subSec.sectionType === CartServices.specialoffer) {
                                if (typeof subSec.products !== "undefined" && subSec.products !== null && subSec.products.length > 0 && subSec.products[0].prodType === Service.streamServ) {
                                    youtubePrd.push(subSec.products[0]);
                                }
                                let replacedPromos = replaceCartDataText(subSec?.promos, CartServices.specialoffer);
                                rewardOffers.push.apply(rewardOffers, replacedPromos);
                                // rewardOffers.push.apply(rewardOffers, subSec.promos);
                                //if(youtubePrd!==null && youtubePrd.length>0){
                                //    rewardOffers.push.apply(rewardOffers, youtubePrd);
                                //}
                            }
                        })
                        cartData.Promotions = Object.assign({ promotions: Promotions })
                        cartData.rewardOffers = Object.assign({ rewardOffers: rewardOffers })
                        cartData.youtubePrd = Object.assign({ youtubePrd: youtubePrd })
                    }
                    else if (cartSection.sectionName === CartServices.oneTimeCharges || cartSection.sectionName === "OTC") {
                        let oneTimeCharge = []
                        oneTimeCharge = getSubProduct(cartSection.subSections.subSection, visitId);
                        cartData.oneTimeCharge = Object.assign({ onetimecharge: oneTimeCharge })
                    }
                    else if(cartSection.sectionName === CartServices.Perks) {
                        console.log('****** perks data 233', cartSection);
                        const prods = cartSection?.subSections?.subSection?.[0]?.products || [];
                        cartData.perks = Object.assign({ perks: prods });
                    }
                    else if (cartSection.sectionName === CartServices.removedperks) {
                        let removedperks = []
                        cartSection.subSections.subSection.forEach(subSec => {                            
                            removedperks.push.apply(removedperks, subSec?.products);
                        })
                        cartData.removedperks = Object.assign({ removedPerks: removedperks })
                    }
                }
                }
                cartspilitData.push(cartData);
                cartData = {};
            }
        }
        else {
            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.CART, visitId, 'getCartData', PAGEACTIVITY.MSG.cartResponseNull, PAGEACTIVITY.UA));
        }
    }
    catch (ex) {
        catchJSException('cartUtility', visitId, 'getCartData', ex);
    }

    return cartspilitData
}

export const getCartProducts = (cartResponse, visitId = null) => {
    let cartProduct = {
        Bundle: null,
        DataProduct: null,
        TvProduct: null,
        VoiceProduct: null,
        CartSubProduct: null,
        Channels: null,
        Listing: null,
        VasProduct: null,
        StreamService: null,
    };
    try {
        let service = getServiceSection(cartResponse, visitId);
        if (InHomeUtils.isNotNull(service)) {
            let subSection = service.subSections.subSection;
            for (let subSectioncount = 0; subSectioncount < subSection.length; subSectioncount++) {
                if (InHomeUtils.isNotNull(subSection[subSectioncount].sectionType)) {
                    if (InHomeUtils.isNotNull(subSection[subSectioncount].products)) {
                        subSection[subSectioncount].products.forEach(prod => {
                            prod["displayPrice"] = prod.price;
                        })
                    }
                    if (subSection[subSectioncount].sectionType === CartServices.bundle) {
                        cartProduct.Bundle = Object.assign({
                            bundleProd: subSection[subSectioncount].products,
                        })
                    }
                    else if (subSection[subSectioncount].sectionType === CartServices.dataStandalone) { //Get the Data Standalone Product
                        cartProduct.DataProduct = Object.assign({
                            dataProd: subSection[subSectioncount].products,
                        })
                    }
                    else if (subSection[subSectioncount].sectionType === CartServices.tvStandalone) {//Get the TV Standalone Product
                        cartProduct.TvProduct = Object.assign({
                            tvProd: subSection[subSectioncount].products,
                        })
                    }
                    else if (subSection[subSectioncount].sectionType === CartServices.voiceStandalone) {//Get the Voice Standalone Product
                        cartProduct.VoiceProduct = Object.assign({
                            voiceProd: subSection[subSectioncount].products,
                        })
                    }
                    if (subSection[subSectioncount].sectionType === CartServices.listing) {
                        cartProduct.Listing = Object.assign({
                            listingProd: subSection[subSectioncount].products,
                        })
                    }
                    if (subSection[subSectioncount].sectionType === CartServices.channel) {
                        cartProduct.Channels = Object.assign({
                            channelProd: subSection[subSectioncount].products,
                        })
                    }
                    if (subSection[subSectioncount].sectionType === CartServices.internet) {
                        if (subSection[subSectioncount].products !== null) {
                            subSection[subSectioncount].products.forEach(prod => {
                                if(prod.isVCloudProd==="Yes"){
                                prod["prodType"] = "PPPCLOUD";                            
                                  
                                }else{
                                prod["prodType"] = "PPP";                            
                                }
                            })
                            cartProduct.Techsure = Object.assign({
                                VasProduct: subSection[subSectioncount].products.filter(each=>((each.prodType==="PPP" || each.prodType==="VHSBILLER") && !(each.prodName && typeof each.prodName === "string" && each.prodName.trim() === "IWMPCHARGEBACK") )).length>0?subSection[subSectioncount].products.filter(each=>((each.prodType==="PPP"||each.prodType==="VHSBILLER") && !(each.prodName && typeof each.prodName === "string" && each.prodName.trim() === "IWMPCHARGEBACK") )):null,
                            })
                            cartProduct.TechsureCloud = Object.assign({
                                VasProduct: subSection[subSectioncount].products.filter(each=>each.prodType==="PPPCLOUD").length>0?subSection[subSectioncount].products.filter(each=>each.prodType==="PPPCLOUD"):null,
                            })
                        }
                        // cartProduct.Techsure = Object.assign({
                        //     VasProduct: subSection[subSectioncount].products,
                        // })
                    }
                    if(subSection[subSectioncount].sectionType === CartServices.streamService){
                        cartProduct.StreamService=Object.assign({
                            streamServiceProds : subSection[subSectioncount].products,
                        })
                    }
                    // if (subSection[subSectioncount].sectionType === CartServices.internet) {
                    //     if (subSection[subSectioncount].products !== null) {
                    //         subSection[subSectioncount].products.forEach(prod => {
                    //             prod["prodType"] = "PPP";
                    //         })
                    //     }
                    //     cartProduct.Techsure = Object.assign({
                    //         VasProduct: subSection[subSectioncount].products,
                    //     })
                    // }
                }
            }
            cartProduct.CartSubProduct = getCartSubProducts(cartResponse, visitId);
        }
        else {
            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.CART, visitId, 'getCartProducts', PAGEACTIVITY.MSG.cartServiceNull, PAGEACTIVITY.UA));
        }
    }
    catch (ex) {
        catchJSException('cartUtility', visitId, 'getCartProducts', ex);
    }
    return cartProduct;
}

export const getCartSubProducts = (cartResponse, visitId = null) => {
    let cartSubProduct = {
        Equipment: null,
        OneTimeCharges: null,
        Promotions: null,
        SpecialOffers: null,
        StreamingDeviceProduct: null,
        PerksProduct:null,
    };
    try {        
        let service = getSubServiceSection(cartResponse, visitId);
        for (let servicecount = 0; servicecount < service.length; servicecount++) {
            if (InHomeUtils.isNotNull(service[servicecount].sectionName)) {
                if (service[servicecount].sectionName === CartServices.equipment) {
                    let equipment = [];
                    for (let subcount = 0; subcount < service[servicecount].subSections.subSection.length; subcount++) {
                        equipment.push.apply(equipment, service[servicecount].subSections.subSection[subcount].products);
                    }
                    cartSubProduct.Equipment = Object.assign({ equipment: equipment })
                }
                if (service[servicecount].sectionName === CartServices.oneTimeCharges) {
                    let oneTimeCharge = [];
                    for (let subcount = 0; subcount < service[servicecount].subSections.subSection.length; subcount++) {
                        oneTimeCharge.push.apply(oneTimeCharge, service[servicecount].subSections.subSection[subcount].products);
                    }
                    cartSubProduct.OneTimeCharges = Object.assign({ oneTimeCharge: oneTimeCharge })
                }
                if (service[servicecount].sectionName === CartServices.Promotions) {
                    let promotions = [];
                    let specialoffers = [];
                    let rewardoffers = [];
                    for (let subcount = 0; subcount < service[servicecount].subSections.subSection.length; subcount++) {
                        if (service[servicecount].subSections.subSection[subcount].sectionType === CartServices.specialoffer) {
                            if (InHomeUtils.isNotEmpty(service[servicecount].subSections.subSection[subcount].products)) {
                                specialoffers.push.apply(specialoffers, service[servicecount].subSections.subSection[subcount].products);
                            }
                            if (InHomeUtils.isNotEmpty(service[servicecount].subSections.subSection[subcount].promos)) {
                                rewardoffers.push.apply(rewardoffers, service[servicecount].subSections.subSection[subcount].promos);
                            }
                        }
                        else if (service[servicecount].subSections.subSection[subcount].sectionType === "Offers") {
                            promotions.push.apply(promotions, service[servicecount].subSections.subSection[subcount].promos);
                        }
                        else {
                            promotions.push.apply(promotions, service[servicecount].subSections.subSection[subcount].promotions);
                        }
                    }
                    cartSubProduct.Promotions = Object.assign({ promotions: promotions })
                    cartSubProduct.SpecialOffers = Object.assign({ specialoffers: specialoffers, rewardoffers: rewardoffers })
                }
                if (service[servicecount].sectionName === CartServices.streamDevice) {
                    let streamDeviceProduct = [];
                    for (let sreamdevicecount = 0; sreamdevicecount < service[servicecount].subSections.subSection.length; sreamdevicecount++) {
                        streamDeviceProduct.push.apply(streamDeviceProduct, service[servicecount].subSections.subSection[sreamdevicecount].products);
                    }
                    cartSubProduct.StreamingDeviceProduct = Object.assign({ streamDeviceProduct: streamDeviceProduct })
                }
                if (service?.[servicecount]?.sectionName === CartServices?.Perks) {
                    let perksProduct = [];
                    for (let perkscount = 0; perkscount < service?.[servicecount]?.subSections?.subSection?.length; perkscount++) {
                        perksProduct.push.apply(perksProduct, service[servicecount].subSections?.subSection?.[perkscount]?.products);
                    }
                    cartSubProduct.PerksProduct = Object.assign({ perksProduct: perksProduct })
                }
            }
        }
    }
    catch (ex) {
        catchJSException('cartUtility', visitId, 'getCartSubProducts', ex);
    }


    return cartSubProduct;
}

export const getSelectedInternet = (cartResponse, visitId = null) => {

    //find the internet sub section
    let dataSection = null;
    try {
        //get the service section data from the cart response 
        let service = getServiceSection(cartResponse, visitId);
        if (InHomeUtils.isNotNull(service) && InHomeUtils.isNotNull(service.subSections) && InHomeUtils.isNotNull(service.subSections.subSection)) {
            let subSection = service.subSections.subSection;
            for (let count = 0; count < subSection.length; count++) {
                if (InHomeUtils.isNotNull(subSection[count].sectionType) && (subSection[count].sectionType.toLowerCase().indexOf("data") > -1 || subSection[count].sectionType === CartServices.bundle) || subSection[count].sectionType === CartServices.dataStandalone) {
                    dataSection = subSection[count].products.filter(prod => prod.prodType === 'FTTPD' || prod.prodType === 'FTTPDDIFF');
                    if (InHomeUtils.isNotNull(dataSection) && dataSection.length > 0) {
                        return dataSection;
                    }
                }
            }
        }
    }
    catch (ex) {
        catchJSException('cartUtility', visitId, 'getSelectedInternet', ex);
    }

    return dataSection;
}


export const getSelectedTv = (cartResponse, visitId = null) => {
    let tvSection = null;
    try {
        //get the service section data from the cart response 
        let service = getServiceSection(cartResponse, visitId);
        //find the tv sub section
        if (InHomeUtils.isNotNull(service) && InHomeUtils.isNotNull(service.subSections) && InHomeUtils.isNotNull(service.subSections.subSection)) {
            let subSection = service.subSections.subSection;
            for (let count = 0; count < subSection.length; count++) {
                if (subSection[count].sectionType.toLowerCase().indexOf("tv") > -1) {
                    tvSection = subSection[count].products[0];
                }
                else if (subSection[count].sectionType === CartServices.bundle) {
                    let products = subSection[count].products;
                    tvSection = products.filter(prod => (prod.prodType === ProductType.TV_BASIC) || (prod.prodType === ProductType.TV_BASICDIFF));
                    tvSection = (tvSection !== undefined && tvSection !== null && tvSection.length > 0) ? tvSection[0] : null;
                }
            }
        }
    }
    catch (ex) {
        catchJSException('cartUtility', visitId, 'getSelectedTv', ex);
    }
    return tvSection;
}

export const getSelectedVoice = (cartResponse, visitId = null) => {

    let voiceSection = null;
    try {
        //get the service section data from the cart response 
        let service = getServiceSection(cartResponse, visitId);
        //find the voice sub section
        if (InHomeUtils.isNotNull(service) && InHomeUtils.isNotNull(service.subSections) && InHomeUtils.isNotNull(service.subSections.subSection)) {
            let subSection = service.subSections.subSection;
            for (let count = 0; count < subSection.length; count++) {
                if (subSection[count].sectionType.toLowerCase().indexOf("voice") > -1) {
                    voiceSection = subSection[count].products[0];
                }
                else if (subSection[count].sectionType === CartServices.bundle) {
                    let products = subSection[count].products;
                    voiceSection = products.filter(prod => prod.prodType === ProductType.VOICE_PRIMARY);
                }
                if (InHomeUtils.isNotNull(voiceSection) && voiceSection.length > 0)
                    return voiceSection;
            }
        }
    }
    catch (ex) {
        catchJSException('cartUtility', visitId, 'getSelectedVoice', ex);
    }
    return voiceSection;
}

export const getSelectedVas = (cartResponse, visitId = null) => {

    let vasSection = null;
    try {
        //get the service section data from the cart response 
        let service = getServiceSection(cartResponse, visitId);
        //find the voice sub section
        if (InHomeUtils.isNotNull(service) && InHomeUtils.isNotNull(service.subSections) && InHomeUtils.isNotNull(service.subSections.subSection)) {
            let subSection = service.subSections.subSection;
            for (let count = 0; count < subSection.length; count++) {
                if (subSection[count].sectionType.toLowerCase().indexOf("vas") > -1) {
                    vasSection = subSection[count].products[0];
                }
                else if (subSection[count].sectionType === CartServices.bundle) {
                    let products = subSection[count].products;
                    vasSection = products.filter(prod => prod.prodType === ProductType.VAS_PLAN);
                }
                if (InHomeUtils.isNotNull(vasSection) && vasSection.length > 0)
                    return vasSection;
            }
        }
    }
    catch (ex) {
        catchJSException('cartUtility', visitId, 'getSelectedVas', ex);
    }
    return vasSection;
}

const getSubsectionItems = (subSections, subSectionItems) => {
    let title = '', price = '';
    if (subSections && subSections.subSection && subSections.subSection.length) {
        let subSection = subSections.subSection;
        for (let subItemIndex in subSection) {
            if (subSection[subItemIndex] && subSection[subItemIndex].products && subSection[subItemIndex].products.length) {
                let subProducts = subSection[subItemIndex].products;
                title = subSection[subItemIndex].title;
                price = subSection[subItemIndex].sectionTotalprice;
                subSectionItems.push.apply(subSectionItems, subProducts);
            }
        }
    }
    return {
        title,
        price
    }
}

const getServiceSection = (cartResponse, visitId = null) => {
    try {
        return cartResponse && cartResponse.tierContent && cartResponse.tierContent[0].sections.section.length > 0 ? cartResponse.tierContent[0].sections.section[0] : null;
    }
    catch (ex) {
        catchJSException('cartUtility', visitId, 'getServiceSection', ex);
    }
}

export const isAutoPayOnProfile = (cartResponse, visitId) => {
    try {
        let isAutoPayOnProfile = false;

        if (cartResponse && cartResponse.tierContent && cartResponse.tierContent.length > 0 && cartResponse.tierContent[0] && cartResponse.tierContent[0].sections && cartResponse.tierContent[0].sections.section && cartResponse.tierContent[0].sections.section.length > 0) {
            let promotionsSection = cartResponse.tierContent[0].sections.section.filter(x => x.sectionName.toLowerCase() == 'promotions');

            if (promotionsSection && promotionsSection.length > 0 && promotionsSection[0].subSections && promotionsSection[0].subSections && promotionsSection[0].subSections.subSection && promotionsSection[0].subSections.subSection.length > 0) {
                let promotionsSubSection = promotionsSection[0].subSections.subSection.filter(x => x.sectionType.toLowerCase() == 'promotions');

                if (promotionsSubSection && promotionsSubSection.length > 0 && promotionsSubSection[0].promotions && promotionsSubSection[0].promotions.length > 0) {
                     let autoPayPromotion = promotionsSubSection?.[0]?.promotions?.filter?.(x => (x?.OfferAttrValue == 'FCP_AUTOPAY_DISCOUNT' || x?.OfferAttrValue?.includes?.("$10_AutoPay") || x?.OfferAttrValue?.includes?.("$5_AutoPay")) && !x?.OfferAttrValue?.toUpperCase?.()?.includes?.("DECLINE"));

                    if (autoPayPromotion && autoPayPromotion.length > 0) {
                        isAutoPayOnProfile = true;
                    }
                }
            }
        }

        return isAutoPayOnProfile;
    }
    catch (ex) {
        catchJSException('cartUtility', visitId, 'isAutoPayOnProfile', ex);
    }
}

const getSubServiceSection = (cartResponse, visitId = null) => {
    try {
        return cartResponse.tierContent[0].sections.section;
    }
    catch (ex) {
        catchJSException('cartUtility', visitId, 'getSubServiceSection', ex);
    }

}

export const getSelectedChannels = (cartResponse, visitId = null) => {
    let channelSection = null;
    try {
        //get the service section data from the cart response 
        let service = getServiceSection(cartResponse, visitId);
        //find the channel sub section
        if (InHomeUtils.isNotNull(service) && InHomeUtils.isNotNull(service.subSections) && InHomeUtils.isNotNull(service.subSections.subSection)) {
            let subSection = service.subSections.subSection;
            for (let count = 0; count < subSection.length; count++) {
                if (subSection[count].sectionType != null && subSection[count].sectionType.toLowerCase().indexOf("channel") > -1) {
                    channelSection = subSection[count].products;
                    return channelSection;
                }
            }
        }
    }
    catch (ex) {
        catchJSException('cartUtility', visitId, 'getSelectedChannels', ex);
    }
    return channelSection;
}
